import { useFormQueryParams } from 'ClientPortal/src/router/useFormQueryParams'
import { useCreateThread } from 'ClientPortal/src/api/Queries/threads'
import { CreateThreadSubmitHandler } from 'ComponentLibrary'
import { UUID } from 'ComponentLibrary/src/common/uuid'
import invariant from 'tiny-invariant'

type UseCreateNewThreadProps = {
    orderId?: UUID
}

export function useCreateNewThread({ orderId }: UseCreateNewThreadProps = {}) {
    const { createThreadMutate: createThread, isCreatingThread } = useCreateThread()

    const { updateMultipleParams } = useFormQueryParams()

    const switchToThreadAndCloseCreate = (thread_uuid: string) => {
        updateMultipleParams({
            create: undefined,
            thread: thread_uuid,
        })
    }

    const onCreateThreadSubmit: CreateThreadSubmitHandler = (data, resetForm) => {
        const selectedOrderId = orderId || data.selectedOrder?.uuid
        invariant(selectedOrderId, 'Cannot create new thread without orderId')
        createThread(
            {
                ...data,
                orderId: selectedOrderId,
                participantIds: data.participants.map((participant) => participant.id),
            },
            {
                onSuccess: (newThread) => {
                    resetForm()
                    switchToThreadAndCloseCreate(newThread.uuid)
                },
            }
        )
    }

    return {
        onCreateThreadSubmit,
        isCreatingThread,
    }
}
